import { Directive, Input } from '@angular/core';
import {
	AbstractControl,
	NG_VALIDATORS,
	ValidationErrors,
	Validator,
	ValidatorFn,
} from '@angular/forms';

@Directive({
	selector: '[maxLength], [maxLengthLabel]',
	providers: [
		{ provide: NG_VALIDATORS, useExisting: MaxLengthDirective, multi: true },
	],
	standalone: false,
})
export class MaxLengthDirective implements Validator {
	@Input('maxLength') maxLength: number;
	@Input('maxLengthLabel') maxLengthLabel: string;

	validate(control: AbstractControl): ValidationErrors | null {
		return this.maxLength
			? MaxLengthValidator(this.maxLength, this.maxLengthLabel)(control)
			: null;
	}
}

export function MaxLengthValidator(
	maxLength: number,
	maxLengthLabel,
): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const { value } = control;

		return !value
			? null
			: value?.length <= maxLength
				? null
				: {
						maxLength: {
							value: `${maxLengthLabel || 'This value'} must be less than ${maxLength} characters.`,
						},
					};
	};
}
